import { render, staticRenderFns } from "./Corporates.vue?vue&type=template&id=0bb6e2bb"
import script from "./Corporates.vue?vue&type=script&lang=js"
export * from "./Corporates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports